const faqQuestions = [
  {
    id: 1,
    question: 'Where do you deliver?',
    answer:
      'We currently deliver to select locations within the Germany. You can check if your location is eligible for delivery by entering your zip code on our website.',
  },
  {
    id: 2,
    question: 'What are the delivery fees?',
    answer:
      'Delivery fees vary depending on the distance between your location and our store. You can view the delivery fee for your area during checkout.',
  },
  {
    id: 3,
    question: 'When will my order be delivered?',
    answer:
      'We offer same-day delivery for orders placed before 1:00 PM. Orders placed after 1:00 PM will be delivered the next day.',
  },
  {
    id: 4,
    question: `What if I'm not home during delivery?`,
    answer: `If you're not home during delivery, our delivery personnel will attempt to contact you to make alternate arrangements. If they are unable to reach you, they will leave the order in a secure location at your address.`,
  },
  {
    id: 5,
    question: 'Can I track my delivery?',
    answer:
      'Yes, you can track the status of your delivery through your account on our website or by clicking on the tracking link provided in your order confirmation email.',
  },
  {
    id: 6,
    question: `What if there's an issue with my delivery?`,
    answer: `If there's an issue with your delivery, please contact our customer service team immediately. We'll do our best to resolve the issue as quickly as possible.`,
  },
];

export { faqQuestions };
